import { Editor } from '@tiptap/core';
import StarterKit from '@tiptap/starter-kit';
import Table from '@tiptap/extension-table';
import TableRow from '@tiptap/extension-table-row';
import TableHeader from '@tiptap/extension-table-header';
import TableCell from '@tiptap/extension-table-cell';
import Link from '@tiptap/extension-link';
import Image from '@tiptap/extension-image';
import type { Extensions } from '@tiptap/core';

/**
 * The Tiptap editor, bundled instead of fetched.
 *
 * Until now infostation.html imported these 8 packages from https://esm.sh at runtime
 * (`?deps=@tiptap/core@2.27.2` to force one shared core across the extensions). That was
 * the single hardest air-gap blocker in the app — with egress blocked, the editor simply
 * never opened — and it also risked silent version drift against the server-side renderer.
 *
 * Bundling fixes both at once. The versions here come from client/package.json, which pins
 * the SAME 2.27.2 as server/package.json, and npm resolves one @tiptap/core for all of
 * them, so the "shared base classes" requirement the ?deps= trick was working around holds
 * structurally rather than by convention.
 *
 * THE EXTENSION SET MUST MATCH server/src/docs/tiptapExtensions.ts EXACTLY. Content is
 * stored as Tiptap JSON and rendered server-side with that list; a mismatch does not error,
 * it silently drops nodes on one side of the round trip.
 */
export type TiptapModules = {
  Editor: typeof Editor;
  extensions: Extensions;
};

export function createTiptapModules(): TiptapModules {
  return {
    Editor,
    extensions: [
      StarterKit,
      Table.configure({ resizable: false }),
      TableRow,
      TableHeader,
      TableCell,
      Link.configure({ openOnClick: false, autolink: false }),
      Image.configure({ inline: true }),
    ],
  };
}
